import { render, staticRenderFns } from "./ClienteleSelect.vue?vue&type=template&id=1c653b1e&scoped=true&"
import script from "./ClienteleSelect.vue?vue&type=script&lang=js&"
export * from "./ClienteleSelect.vue?vue&type=script&lang=js&"
import style0 from "./ClienteleSelect.vue?vue&type=style&index=0&id=1c653b1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c653b1e",
  null
  
)

export default component.exports